// eslint-disable-next-line import/no-cycle
import {
  ComponentNameEnum,
  ConfigurationPanelStructure,
  ConfigurationPanelStructureItemEnum,
  TemplateStructureEnum,
  TabItem,
  StepperSignEnum,
  Property,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import textStylesFieldConfig from '@/components/template-builder/config/fields/text-styles-config';
// eslint-disable-next-line import/no-cycle
import getTextAlignFieldConfig from '@/components/template-builder/config/fields/text-align-config';
// eslint-disable-next-line import/no-cycle
import getTextAlignNoJustifyFieldConfig from '@/components/template-builder/config/fields/text-align-no-justify-config';
// eslint-disable-next-line import/no-cycle
import getBorderRadiusFieldConfig from '@/components/template-builder/config/fields/border-radius-config';
// eslint-disable-next-line import/no-cycle
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
// eslint-disable-next-line import/no-cycle
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import modelWidthFieldConfig from '@/components/template-builder/config/fields/model-width-config';
// eslint-disable-next-line import/no-cycle
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
// eslint-disable-next-line import/no-cycle
import getWidthFieldConfig from '@/components/template-builder/config/fields/width-config';
// eslint-disable-next-line import/no-cycle
import {
  cleanCssByProperty,
  toggleMobileStyle,
  setCssButtonWidthProperty,
  setCssButtonDisplayProperty,
  setCssPropertyWithImportantAndRemoveIfZero,
  setCssPropertyWithImportant, setCssProperty, setCssPropertyAndRemoveIfZero,
  setButtonAlignment,
  setCssPropertyWithOutlookFontHack,
  updateOutlookFontHackWithComputedStyle,
  setButtonBorderRadius,
  cleanupButtonVml,
  refreshButtonVml,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import { getCssPropertyByName, getAttributeByName, getRelativeWidth } from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import getStepperFieldConfig from '@/components/template-builder/config/fields/stepper-config';
// eslint-disable-next-line import/no-cycle
import lineHeightFieldConfig from '@/components/template-builder/config/fields/line-height-config';
// eslint-disable-next-line import/no-cycle
import fontFieldConfig from '@/components/template-builder/config/fields/font-config';
// eslint-disable-next-line import/no-cycle
import getButtonWidthFieldConfig from '@/components/template-builder/config/fields/button-width-config';
// eslint-disable-next-line import/no-cycle
import getElementAlignFieldConfig from '@/components/template-builder/config/fields/element-align-config';
// eslint-disable-next-line import/no-cycle
import { getElementFromIframe } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import { HIDE_MOBILE_ATTRIBUTE } from '@/components/template-builder/utils/constants';

const initMobileVersionHandler = (structureId: string) => {
  const structure = getElementFromIframe(`#${structureId}`);
  let returnValue = true;
  if (structure) {
    const parentSection = structure.getAttribute('data-spmelementid') ? structure : structure.closest('[data-spmelementid]');
    if (parentSection && parentSection.getAttribute(HIDE_MOBILE_ATTRIBUTE)) {
      returnValue = false;
    }
  }
  return returnValue;
};

export const pageTabItemConfig: TabItem = {
  type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
  tabItemType: TemplateStructureEnum.PAGE,
  label: 'templateBuilder.configs.page',
  canToggleSettings: {
    'templateBuilder.configs.mobileVersion': {
      initValueHandler: initMobileVersionHandler,
      label: 'templateBuilder.toogleMobileActiveLabel',
      tooltipLabel: 'templateBuilder.toogleMobileActiveTooltip',
    },
  },
  tabPanel: {
    label: 'templateBuilder.configs.page',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.pageStyles',
        selector: 'table#spm_body',
        items: [
          {
            label: 'templateBuilder.fields.backgroundColor',
            selector: 'table#spm_body',
            properties: [{ name: 'background-color', getter: getCssPropertyByName, setters: [setCssProperty] }],
            ...getColorFieldConfig('#ffffff', false, false, true),
          },
          {
            label: 'templateBuilder.fields.backgroundColorCentralArea',
            selector: 'table#spm_body table.container',
            properties: [{ name: 'background-color', getter: getCssPropertyByName, setters: [setCssProperty] }],
            ...getColorFieldConfig('#ffffff', false, false, true),
          },
          {
            label: 'templateBuilder.fields.modelWidth',
            selector: 'table#spm_body table.container',
            properties: [
              { name: 'width', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'min-width', getter: getCssPropertyByName, setters: [setCssProperty] },
            ],
            ...modelWidthFieldConfig,
          },
          {
            label: 'templateBuilder.fields.borders',
            selector: 'table#spm_body',
            properties: [
              { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-style', getter: getCssPropertyByName, setters: [] },
              { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
              { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
              { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
              { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
            ],
            ...bordersFieldConfig,
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.pageMargins',
        selector: 'table#spm_body',
        items: [
          {
            label: 'templateBuilder.fields.pageInnerMargins',
            selector: '#spm_body > tbody > tr > td',
            properties: [
              { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
            },
          },
          {
            label: 'templateBuilder.fields.sectionInnerMargins',
            selector: '#spm_body .spm_section > tbody > tr > td',
            properties: [
              { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
            },
          },
          {
            label: 'templateBuilder.fields.lineInnerMargins',
            selector: '#spm_body table.spm_draggable_row > tbody > tr > td',
            properties: [
              { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-left', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-right', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
              ...getHorizontalSpacesFieldConfig('padding').options,
            },
          },
          {
            label: 'templateBuilder.fields.widgetInnerMargins',
            selector: '#spm_body table.spm_draggable_widget > tbody > tr > th',
            properties: [
              { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-left', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'padding-right', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
              ...getHorizontalSpacesFieldConfig().options,
            },
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        tabItemType: TemplateStructureEnum.GROUP,
        label: 'templateBuilder.configs.pageTextsAndTitles',
        scrollable: true,
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.pageTexts',
              selector: 'table#spm_body',
              items: [
                {
                  label: 'templateBuilder.fields.font',
                  selector: '{SELECTOR} table.spm_draggable_widget>tbody>tr>th',
                  mobile: false,
                  onToggleOff: (selector: string) => updateOutlookFontHackWithComputedStyle(selector),
                  onToggleOn: (selector: string) => updateOutlookFontHackWithComputedStyle(selector),
                  properties: [
                    { name: 'font-family', getter: getCssPropertyByName, setters: [setCssPropertyWithOutlookFontHack] },
                    { name: 'font-size', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-weight', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-decoration-line', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-transform', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'color', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.textAlign',
                  selector: '{SELECTOR} table.spm_draggable_widget>tbody>tr>th, {SELECTOR} table.spm_draggable_widget>tbody>tr>th p',
                  mobile: false,
                  properties: [
                    {
                      name: 'text-align',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getTextAlignFieldConfig(),
                },
                {
                  label: 'templateBuilder.fields.lineHeight.label',
                  selector: '{SELECTOR} table.spm_draggable_widget>tbody>tr>th',
                  mobile: false,
                  properties: [
                    {
                      name: 'line-height',
                      getter: getCssPropertyByName,
                      setters: [cleanCssByProperty, setCssProperty],
                    },
                  ],
                  ...lineHeightFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.spaceBetweenChars',
                  selector: '{SELECTOR} table.spm_draggable_widget>tbody>tr>th',
                  mobile: false,
                  properties: [
                    {
                      name: 'letter-spacing',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getStepperFieldConfig(StepperSignEnum.PX),
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.pageLinks',
              selector: 'table#spm_body',
              items: [
                {
                  label: 'templateBuilder.fields.color',
                  selector: '{SELECTOR} a, {SELECTOR} a:hover, {SELECTOR} a:visited, {SELECTOR} a:active',
                  mobile: false,
                  properties: [
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getColorFieldConfig('#333333'),
                  options: {
                    defaultValue: '#2795b6',
                  },
                },
                {
                  label: 'templateBuilder.fields.style',
                  selector: '{SELECTOR} a, {SELECTOR} a:hover, {SELECTOR} a:visited, {SELECTOR} a:active',
                  mobile: false,
                  properties: [
                    { name: 'font-weight', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-decoration-line', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-transform', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  ...textStylesFieldConfig,
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.title1',
              selector: 'table#spm_body',
              items: [
                {
                  label: 'templateBuilder.fields.font',
                  selector: '{SELECTOR} h1, {SELECTOR} h1 a, {SELECTOR} h1 a:hover, {SELECTOR} h1 a:visited, {SELECTOR} h1 a:active',
                  mobile: false,
                  properties: [
                    { name: 'font-family', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-size', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-weight', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-decoration-line', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-transform', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'color', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.titleMarginVertical',
                  selector: '{SELECTOR} h1',
                  mobile: false,
                  properties: [
                    {
                      name: 'margin-top',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-bottom',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getVerticalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.titleMarginHorizontal',
                  selector: '{SELECTOR} h1',
                  mobile: false,
                  properties: [
                    {
                      name: 'margin-left',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-right',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getHorizontalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.lineHeight.label',
                  selector: '{SELECTOR} h1, {SELECTOR} h1 a, {SELECTOR} h1 a:hover, {SELECTOR} h1 a:visited, {SELECTOR} h1 a:active',
                  mobile: false,
                  properties: [{
                    name: 'line-height',
                    getter: getCssPropertyByName,
                    setters: [setCssProperty],
                  }],
                  ...lineHeightFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.spaceBetweenChars',
                  selector: '{SELECTOR} h1, {SELECTOR} h1 a, {SELECTOR} h1 a:hover, {SELECTOR} h1 a:visited, {SELECTOR} h1 a:active',
                  mobile: false,
                  properties: [{
                    name: 'letter-spacing',
                    getter: getCssPropertyByName,
                    setters: [setCssProperty],
                  }],
                  ...getStepperFieldConfig(StepperSignEnum.PX),
                },
                {
                  label: 'templateBuilder.fields.titleAlign',
                  selector: '{SELECTOR} h1, {SELECTOR} h1 a, {SELECTOR} h1 a:hover, {SELECTOR} h1 a:visited, {SELECTOR} h1 a:active',
                  mobile: false,
                  properties: [{
                    name: 'text-align',
                    getter: getCssPropertyByName,
                    setters: [setCssProperty],
                  }],
                  ...getTextAlignFieldConfig(),
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.title2',
              selector: 'table#spm_body',
              items: [
                {
                  label: 'templateBuilder.fields.font',
                  selector: '{SELECTOR} h2, {SELECTOR} h2 a, {SELECTOR} h2 a:hover, {SELECTOR} h2 a:visited, {SELECTOR} h2 a:active',
                  mobile: false,
                  properties: [
                    { name: 'font-family', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-size', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-weight', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-decoration-line', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-transform', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'color', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.titleMarginVertical',
                  selector: '{SELECTOR} h2',
                  mobile: false,
                  properties: [
                    {
                      name: 'margin-top',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-bottom',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getVerticalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.titleMarginHorizontal',
                  selector: '{SELECTOR} h2',
                  mobile: false,
                  properties: [
                    {
                      name: 'margin-left',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-right',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getHorizontalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.lineHeight.label',
                  selector: '{SELECTOR} h2, {SELECTOR} h2 a, {SELECTOR} h2 a:hover, {SELECTOR} h2 a:visited, {SELECTOR} h2 a:active',
                  mobile: false,
                  properties: [{
                    name: 'line-height',
                    getter: getCssPropertyByName,
                    setters: [setCssProperty],
                  }],
                  ...lineHeightFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.spaceBetweenChars',
                  selector: '{SELECTOR} h2, {SELECTOR} h2 a, {SELECTOR} h2 a:hover, {SELECTOR} h2 a:visited, {SELECTOR} h2 a:active',
                  mobile: false,
                  properties: [{
                    name: 'letter-spacing',
                    getter: getCssPropertyByName,
                    setters: [setCssProperty],
                  }],
                  ...getStepperFieldConfig(StepperSignEnum.PX),
                },
                {
                  label: 'templateBuilder.fields.titleAlign',
                  selector: '{SELECTOR} h2, {SELECTOR} h2 a, {SELECTOR} h2 a:hover, {SELECTOR} h2 a:visited, {SELECTOR} h2 a:active',
                  mobile: false,
                  properties: [{
                    name: 'text-align',
                    getter: getCssPropertyByName,
                    setters: [setCssProperty],
                  }],
                  ...getTextAlignFieldConfig(),
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.title3',
              selector: 'table#spm_body',
              items: [
                {
                  label: 'templateBuilder.fields.font',
                  selector: '{SELECTOR} h3, {SELECTOR} h3 a, {SELECTOR} h3 a:hover, {SELECTOR} h3 a:visited, {SELECTOR} h3 a:active',
                  mobile: false,
                  properties: [
                    { name: 'font-family', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-size', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-weight', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-decoration-line', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-transform', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'color', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.titleMarginVertical',
                  selector: '{SELECTOR} h3',
                  mobile: false,
                  properties: [
                    {
                      name: 'margin-top',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-bottom',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getVerticalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.titleMarginHorizontal',
                  selector: '{SELECTOR} h3',
                  mobile: false,
                  properties: [
                    {
                      name: 'margin-left',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-right',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getHorizontalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.lineHeight.label',
                  selector: '{SELECTOR} h3, {SELECTOR} h3 a, {SELECTOR} h3 a:hover, {SELECTOR} h3 a:visited, {SELECTOR} h3 a:active',
                  mobile: false,
                  properties: [{
                    name: 'line-height',
                    getter: getCssPropertyByName,
                    setters: [setCssProperty],
                  }],
                  ...lineHeightFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.spaceBetweenChars',
                  selector: '{SELECTOR} h3, {SELECTOR} h3 a, {SELECTOR} h3 a:hover, {SELECTOR} h3 a:visited, {SELECTOR} h3 a:active',
                  mobile: false,
                  properties: [{
                    name: 'letter-spacing',
                    getter: getCssPropertyByName,
                    setters: [setCssProperty],
                  }],
                  ...getStepperFieldConfig(StepperSignEnum.PX),
                },
                {
                  label: 'templateBuilder.fields.titleAlign',
                  selector: '{SELECTOR} h3, {SELECTOR} h3 a, {SELECTOR} h3 a:hover, {SELECTOR} h3 a:visited, {SELECTOR} h3 a:active',
                  mobile: false,
                  properties: [{
                    name: 'text-align',
                    getter: getCssPropertyByName,
                    setters: [setCssProperty],
                  }],
                  ...getTextAlignFieldConfig(),
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.title4',
              selector: 'table#spm_body',
              items: [
                {
                  label: 'templateBuilder.fields.font',
                  selector: '{SELECTOR} h4, {SELECTOR} h4 a, {SELECTOR} h4 a:hover, {SELECTOR} h4 a:visited, {SELECTOR} h4 a:active',
                  mobile: false,
                  properties: [
                    { name: 'font-family', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-size', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-weight', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-decoration-line', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-transform', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'color', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.titleMarginVertical',
                  selector: '{SELECTOR} h4',
                  mobile: false,
                  properties: [
                    {
                      name: 'margin-top',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-bottom',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getVerticalSpacesFieldConfig('margin', 10),
                },
                {
                  label: 'templateBuilder.fields.titleMarginHorizontal',
                  selector: '{SELECTOR} h4, {SELECTOR} h4 a, {SELECTOR} h4 a:hover, {SELECTOR} h4 a:visited, {SELECTOR} h4 a:active',
                  mobile: false,
                  properties: [
                    {
                      name: 'margin-left',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'margin-right',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...getHorizontalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.lineHeight.label',
                  selector: '{SELECTOR} h4, {SELECTOR} h4 a, {SELECTOR} h4 a:hover, {SELECTOR} h4 a:visited, {SELECTOR} h4 a:active',
                  mobile: false,
                  properties: [{
                    name: 'line-height',
                    getter: getCssPropertyByName,
                    setters: [setCssProperty],
                  }],
                  ...lineHeightFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.spaceBetweenChars',
                  selector: '{SELECTOR} h4, {SELECTOR} h4 a, {SELECTOR} h4 a:hover, {SELECTOR} h4 a:visited, {SELECTOR} h4 a:active',
                  mobile: false,
                  properties: [{
                    name: 'letter-spacing',
                    getter: getCssPropertyByName,
                    setters: [setCssProperty],
                  }],
                  ...getStepperFieldConfig(StepperSignEnum.PX),
                },
                {
                  label: 'templateBuilder.fields.titleAlign',
                  selector: '{SELECTOR} h4',
                  mobile: false,
                  properties: [{
                    name: 'text-align',
                    getter: getCssPropertyByName,
                    setters: [setCssProperty],
                  }],
                  ...getTextAlignFieldConfig(),
                },
              ],
            },
          ],
        },
      },
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.pageButtons',
        selector: 'table#spm_body',
        items: [
          {
            label: 'templateBuilder.fields.contours',
            selector: '{SELECTOR} table.spm_button th a, {SELECTOR} table.spm_button th a:hover, {SELECTOR} table.spm_button th a:visited, {SELECTOR} table.spm_button th a:active',
            properties: [{ name: 'border-radius', getter: getCssPropertyByName, setters: [setButtonBorderRadius] }],
            onToggleOff: (selector: string) => {
              refreshButtonVml(selector);
            },
            onToggleOn: (selector: string) => {
              refreshButtonVml(selector);
            },
            ...getBorderRadiusFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.borders',
            selector: '{SELECTOR} table.spm_button th a, {SELECTOR} table.spm_button th a:hover, {SELECTOR} table.spm_button th a:visited, {SELECTOR} table.spm_button th a:active',
            properties: [
              { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty, (selector: string) => { refreshButtonVml(selector); }] },
              { name: 'border-style', getter: getCssPropertyByName, setters: [] },
              { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero, (selector: string) => { refreshButtonVml(selector); }] },
              { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
              { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
              { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
              { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
            ],
            ...bordersFieldConfig,
          },
          {
            label: 'templateBuilder.fields.backgroundColor',
            selector: '{SELECTOR} table.spm_button th a, {SELECTOR} table.spm_button th a:hover, {SELECTOR} table.spm_button th a:visited, {SELECTOR} table.spm_button th a:active',
            properties: [{
              name: 'background-color',
              getter: getCssPropertyByName,
              setters: [
                setCssProperty,
                (selector: string) => { refreshButtonVml(selector); },
              ],
            }],
            onToggleOff: (selector: string) => {
              refreshButtonVml(selector);
            },
            onToggleOn: (selector: string) => {
              refreshButtonVml(selector);
            },
            ...getColorFieldConfig(),
            options: {
              defaultValue: '#E0E0E0',
            },
          },
          {
            label: 'templateBuilder.fields.font',
            selector: '{SELECTOR} table.spm_button th, {SELECTOR} table.spm_button:hover th, {SELECTOR} table.spm_button:visited th, {SELECTOR} table.spm_button:active th, {SELECTOR} '
              + 'table.spm_button:hover th a, {SELECTOR} table.spm_button th a, {SELECTOR} table.spm_button th a:visited, {SELECTOR} table.spm_button th a:hover, {SELECTOR} table.spm_button '
              + 'th a:active',
            properties: [
              { name: 'font-family', getter: getCssPropertyByName, setters: [setCssProperty, (selector: string) => { refreshButtonVml(selector); }] },
              { name: 'font-size', getter: getCssPropertyByName, setters: [setCssProperty, (selector: string) => { refreshButtonVml(selector); }] },
              { name: 'font-weight', getter: getCssPropertyByName, setters: [setCssProperty, (selector: string) => { refreshButtonVml(selector); }] },
              { name: 'font-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'text-decoration-line', getter: getCssPropertyByName, setters: [setCssProperty, (selector: string) => { refreshButtonVml(selector); }] },
              { name: 'text-transform', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'color', getter: getCssPropertyByName, setters: [setCssProperty, (selector: string) => { refreshButtonVml(selector); }] },
            ],
            onToggleOff: (selector: string) => {
              refreshButtonVml(selector);
            },
            onToggleOn: (selector: string) => {
              refreshButtonVml(selector);
            },
            ...fontFieldConfig,
          },
          {
            label: 'templateBuilder.fields.lineHeight.label',
            selector: '{SELECTOR} table.spm_button th, {SELECTOR} table.spm_button:hover th, {SELECTOR} table.spm_button:visited th, {SELECTOR} table.spm_button:active th',
            properties: [{ name: 'line-height', getter: getCssPropertyByName, setters: [cleanCssByProperty, setCssProperty] }],
            ...lineHeightFieldConfig,
          },
          {
            label: 'templateBuilder.fields.textAlign',
            selector: '{SELECTOR} table.spm_button th a',
            properties: [{ name: 'text-align', getter: getCssPropertyByName, setters: [setCssProperty, (selector: string) => { refreshButtonVml(selector); }] }],
            ...getTextAlignNoJustifyFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.spaceBetweenChars',
            selector: '{SELECTOR} table.spm_button th, {SELECTOR} table.spm_button:hover th, {SELECTOR} table.spm_button:visited th, {SELECTOR} table.spm_button:active th, '
              + '{SELECTOR} table.spm_button:hover th a, {SELECTOR} table.spm_button th a, {SELECTOR} table.spm_button th a:visited, {SELECTOR} table.spm_button th a:hover, '
              + '{SELECTOR} table.spm_button th a:active',
            properties: [{ name: 'letter-spacing', getter: getCssPropertyByName, setters: [setCssProperty] }],
            ...getStepperFieldConfig(StepperSignEnum.PX),
          },
          {
            label: 'templateBuilder.fields.buttonWidth',
            selector: '{SELECTOR} table.spm_button th a',
            properties: [{
              name: 'display',
              getter: getCssPropertyByName,
              setters: [setCssButtonDisplayProperty, (selector: string) => { refreshButtonVml(selector); }],
            }],
            onToggleOff: (selector: string) => {
              refreshButtonVml(selector);
            },
            onToggleOn: (selector: string) => {
              refreshButtonVml(selector);
            },
            ...getButtonWidthFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.buttonAlignment',
            selector: '{SELECTOR} table.spm_button th',
            properties: [{ name: 'text-align', getter: getCssPropertyByName, setters: [setCssProperty, (selector: string) => { refreshButtonVml(selector); }] }],
            ...getTextAlignNoJustifyFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.spaceWithinButton',
            selector: '{SELECTOR} table.spm_button th a, {SELECTOR} table.spm_button th a:hover, {SELECTOR} table.spm_button th a:visited, {SELECTOR} table.spm_button th a:active',
            properties: [
              { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero, (selector: string) => { refreshButtonVml(selector); }] },
              { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero, (selector: string) => { refreshButtonVml(selector); }] },
              { name: 'padding-left', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero, (selector: string) => { refreshButtonVml(selector); }] },
              { name: 'padding-right', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero, (selector: string) => { refreshButtonVml(selector); }] },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
              ...getHorizontalSpacesFieldConfig().options,
            },
            onToggleOff: (selector: string) => { refreshButtonVml(selector); },
            onToggleOn: (selector: string) => { refreshButtonVml(selector); },
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.separators',
        selector: 'table#spm_body',
        items: [
          {
            label: 'templateBuilder.fields.style',
            selector: '{SELECTOR} .spm_widget_separator > tbody > tr > th table.spm_separator th',
            properties: [
              { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
              { name: 'border-style', getter: getCssPropertyByName, setters: [] },
              { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
              { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
              { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
            ],
            ...bordersFieldConfig,
          },
          {
            label: 'templateBuilder.fields.width',
            selector: '{SELECTOR} .spm_widget_separator > tbody > tr > th table.spm_separator',
            properties: [{ name: 'width', getter: getRelativeWidth, setters: [setCssProperty] }],
            ...getWidthFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.marginVertical',
            selector: '{SELECTOR} .spm_widget_separator > tbody > tr > th',
            properties: [
              { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssPropertyWithImportantAndRemoveIfZero] },
              { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssPropertyWithImportantAndRemoveIfZero] },
            ],
            ...getVerticalSpacesFieldConfig(),
          },
          {
            label: 'templateBuilder.fields.marginHorizontal',
            selector: '{SELECTOR} .spm_widget_separator > tbody > tr > th',
            properties: [
              { name: 'padding-left', getter: getCssPropertyByName, setters: [setCssPropertyWithImportantAndRemoveIfZero] },
              { name: 'padding-right', getter: getCssPropertyByName, setters: [setCssPropertyWithImportantAndRemoveIfZero] },
            ],
            ...getHorizontalSpacesFieldConfig(),
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.PARENT_FIELDS,
        label: 'templateBuilder.configs.mobileVersion',
        toggleHandler: toggleMobileStyle,
        fieldGroups: [
          {
            type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
            tabItemType: TemplateStructureEnum.GROUP,
            label: 'templateBuilder.configs.pageTextsAndTitles',
            scrollable: true,
            tabPanel: {
              items: [
                {
                  type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
                  label: 'templateBuilder.configs.pageTexts',
                  selector: 'table#spm_body',
                  items: [
                    {
                      label: 'templateBuilder.fields.font',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR}, {SELECTOR} td, {SELECTOR} th, {SELECTOR} th p, {SELECTOR} .spm_rich_editor p *, {SELECTOR} td .spm_rich_editor p *, {SELECTOR} th .spm_rich_editor p *',
                      mobile: true,
                      properties: [
                        {
                          name: 'font-family',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-size',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-weight',
                          customSelector: '{SELECTOR}, {SELECTOR} td, {SELECTOR} th',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-style',
                          customSelector: '{SELECTOR}, {SELECTOR} td, {SELECTOR} th',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'text-decoration-line',
                          customSelector: '{SELECTOR}, {SELECTOR} td, {SELECTOR} th',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'text-transform',
                          customSelector: '{SELECTOR}, {SELECTOR} td, {SELECTOR} th',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...fontFieldConfig,
                    },
                    {
                      label: 'templateBuilder.fields.lineHeight.label',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR}, {SELECTOR} td, {SELECTOR} th, {SELECTOR} th p, {SELECTOR} th p, {SELECTOR} .spm_rich_editor p *, {SELECTOR} td .spm_rich_editor p *, {SELECTOR} th .spm_rich_editor p *',
                      mobile: true,
                      properties: [
                        {
                          name: 'line-height',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => cleanCssByProperty(selector, property, true),
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...lineHeightFieldConfig,
                    },
                    {
                      label: 'templateBuilder.fields.spaceBetweenChars',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR}, {SELECTOR} td, {SELECTOR} th, {SELECTOR} th p, {SELECTOR} .spm_rich_editor p *, {SELECTOR} td .spm_rich_editor p *, {SELECTOR} th .spm_rich_editor p *',
                      mobile: true,
                      properties: [
                        {
                          name: 'letter-spacing',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...getStepperFieldConfig(StepperSignEnum.PX),
                    },
                    {
                      label: 'templateBuilder.fields.textAlign',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR}, {SELECTOR} td, {SELECTOR} th, {SELECTOR} th p, {SELECTOR} .spm_rich_editor p *, {SELECTOR} td .spm_rich_editor p *, {SELECTOR} th .spm_rich_editor p *',
                      mobile: true,
                      properties: [
                        {
                          name: 'text-align',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...getTextAlignFieldConfig(),
                    },
                  ],
                },
                {
                  type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
                  label: 'templateBuilder.configs.title1',
                  selector: 'table#spm_body',
                  items: [
                    {
                      label: 'templateBuilder.fields.font',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1, {SELECTOR} .spm_rich_editor h1 *, {SELECTOR} td .spm_rich_editor h1 *, {SELECTOR} th .spm_rich_editor h1 *',
                      mobile: true,
                      properties: [
                        {
                          name: 'font-family',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-size',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-weight',
                          customSelector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-style',
                          customSelector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'text-decoration-line',
                          customSelector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'text-transform',
                          customSelector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...fontFieldConfig,
                    },
                    {
                      label: 'templateBuilder.fields.lineHeight.label',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1, {SELECTOR} .spm_rich_editor h1 *, {SELECTOR} td .spm_rich_editor h1 *, {SELECTOR} th .spm_rich_editor h1 *',
                      mobile: true,
                      properties: [{
                        name: 'line-height',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...lineHeightFieldConfig,
                    },
                    {
                      label: 'templateBuilder.fields.spaceBetweenChars',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1, {SELECTOR} .spm_rich_editor h1 *, {SELECTOR} td .spm_rich_editor h1 *, {SELECTOR} th .spm_rich_editor h1 *',
                      mobile: true,
                      properties: [{
                        name: 'letter-spacing',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...getStepperFieldConfig(StepperSignEnum.PX),
                    },
                    {
                      label: 'templateBuilder.fields.titleAlign',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1, {SELECTOR} .spm_rich_editor h1 *, {SELECTOR} td .spm_rich_editor h1 *, {SELECTOR} th .spm_rich_editor h1 *',
                      mobile: true,
                      properties: [{
                        name: 'text-align',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...getTextAlignFieldConfig(),
                    },
                    {
                      label: 'templateBuilder.fields.titleMarginVertical',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1, {SELECTOR} .spm_rich_editor h1 *, {SELECTOR} td .spm_rich_editor h1 *, {SELECTOR} th .spm_rich_editor h1 *',
                      mobile: true,
                      properties: [
                        {
                          name: 'margin-top',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'margin-bottom',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...getVerticalSpacesFieldConfig('margin'),
                    },
                    {
                      label: 'templateBuilder.fields.titleMarginHorizontal',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h1, {SELECTOR} td h1, {SELECTOR} th h1, {SELECTOR} .spm_rich_editor h1 *, {SELECTOR} td .spm_rich_editor h1 *, {SELECTOR} th .spm_rich_editor h1 *',
                      mobile: true,
                      properties: [
                        {
                          name: 'margin-left',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'margin-right',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...getHorizontalSpacesFieldConfig('margin'),
                    },
                  ],
                },
                {
                  type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
                  label: 'templateBuilder.configs.title2',
                  selector: 'table#spm_body',
                  items: [
                    {
                      label: 'templateBuilder.fields.font',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2, {SELECTOR} .spm_rich_editor h2 *, {SELECTOR} td .spm_rich_editor h2 *, {SELECTOR} th .spm_rich_editor h2 *',
                      mobile: true,
                      properties: [
                        {
                          name: 'font-family',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-size',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-weight',
                          customSelector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-style',
                          customSelector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'text-decoration-line',
                          customSelector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'text-transform',
                          customSelector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...fontFieldConfig,
                    },
                    {
                      label: 'templateBuilder.fields.lineHeight.label',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2, {SELECTOR} .spm_rich_editor h2 *, {SELECTOR} td .spm_rich_editor h2 *, {SELECTOR} th .spm_rich_editor h2 *',
                      mobile: true,
                      properties: [{
                        name: 'line-height',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...lineHeightFieldConfig,
                    },
                    {
                      label: 'templateBuilder.fields.spaceBetweenChars',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2, {SELECTOR} .spm_rich_editor h2 *, {SELECTOR} td .spm_rich_editor h2 *, {SELECTOR} th .spm_rich_editor h2 *',
                      mobile: true,
                      properties: [{
                        name: 'letter-spacing',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...getStepperFieldConfig(StepperSignEnum.PX),
                    },
                    {
                      label: 'templateBuilder.fields.titleAlign',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2, {SELECTOR} .spm_rich_editor h2 *, {SELECTOR} td .spm_rich_editor h2 *, {SELECTOR} th .spm_rich_editor h2 *',
                      mobile: true,
                      properties: [{
                        name: 'text-align',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...getTextAlignFieldConfig(),
                    },
                    {
                      label: 'templateBuilder.fields.titleMarginVertical',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2, {SELECTOR} .spm_rich_editor h2 *, {SELECTOR} td .spm_rich_editor h2 *, {SELECTOR} th .spm_rich_editor h2 *',
                      mobile: true,
                      properties: [
                        {
                          name: 'margin-top',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'margin-bottom',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...getVerticalSpacesFieldConfig('margin'),
                    },
                    {
                      label: 'templateBuilder.fields.titleMarginHorizontal',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h2, {SELECTOR} td h2, {SELECTOR} th h2, {SELECTOR} .spm_rich_editor h2 *, {SELECTOR} td .spm_rich_editor h2 *, {SELECTOR} th .spm_rich_editor h2 *',
                      mobile: true,
                      properties: [
                        {
                          name: 'margin-left',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'margin-right',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...getHorizontalSpacesFieldConfig('margin'),
                    },
                  ],
                },
                {
                  type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
                  label: 'templateBuilder.configs.title3',
                  selector: 'table#spm_body',
                  items: [
                    {
                      label: 'templateBuilder.fields.font',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3, {SELECTOR} .spm_rich_editor h3 *, {SELECTOR} td .spm_rich_editor h3 *, {SELECTOR} th .spm_rich_editor h3 *',
                      mobile: true,
                      properties: [
                        {
                          name: 'font-family',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-size',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-weight',
                          customSelector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-style',
                          customSelector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'text-decoration-line',
                          customSelector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'text-transform',
                          customSelector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...fontFieldConfig,
                    },
                    {
                      label: 'templateBuilder.fields.lineHeight.label',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3, {SELECTOR} .spm_rich_editor h3 *, {SELECTOR} td .spm_rich_editor h3 *, {SELECTOR} th .spm_rich_editor h3 *',
                      mobile: true,
                      properties: [{
                        name: 'line-height',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...lineHeightFieldConfig,
                    },
                    {
                      label: 'templateBuilder.fields.spaceBetweenChars',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3, {SELECTOR} .spm_rich_editor h3 *, {SELECTOR} td .spm_rich_editor h3 *, {SELECTOR} th .spm_rich_editor h3 *',
                      mobile: true,
                      properties: [{
                        name: 'letter-spacing',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...getStepperFieldConfig(StepperSignEnum.PX),
                    },
                    {
                      label: 'templateBuilder.fields.titleAlign',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3, {SELECTOR} .spm_rich_editor h3 *, {SELECTOR} td .spm_rich_editor h3 *, {SELECTOR} th .spm_rich_editor h3 *',
                      mobile: true,
                      properties: [{
                        name: 'text-align',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...getTextAlignFieldConfig(),
                    },
                    {
                      label: 'templateBuilder.fields.titleMarginVertical',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3, {SELECTOR} .spm_rich_editor h3 *, {SELECTOR} td .spm_rich_editor h3 *, {SELECTOR} th .spm_rich_editor h3 *',
                      mobile: true,
                      properties: [
                        {
                          name: 'margin-top',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'margin-bottom',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...getVerticalSpacesFieldConfig('margin'),
                    },
                    {
                      label: 'templateBuilder.fields.titleMarginHorizontal',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h3, {SELECTOR} td h3, {SELECTOR} th h3, {SELECTOR} .spm_rich_editor h3 *, {SELECTOR} td .spm_rich_editor h3 *, {SELECTOR} th .spm_rich_editor h3 *',
                      mobile: true,
                      properties: [
                        {
                          name: 'margin-left',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'margin-right',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...getHorizontalSpacesFieldConfig('margin'),
                    },
                  ],
                },
                {
                  type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
                  label: 'templateBuilder.configs.title4',
                  selector: 'table#spm_body',
                  items: [
                    {
                      label: 'templateBuilder.fields.font',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4, {SELECTOR} .spm_rich_editor h4 *, {SELECTOR} td .spm_rich_editor h4 *, {SELECTOR} th .spm_rich_editor h4 *',
                      mobile: true,
                      properties: [
                        {
                          name: 'font-family',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-size',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-weight',
                          customSelector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-style',
                          customSelector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'text-decoration-line',
                          customSelector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'text-transform',
                          customSelector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...fontFieldConfig,
                    },

                    {
                      label: 'templateBuilder.fields.lineHeight.label',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4, {SELECTOR} .spm_rich_editor h4 *, {SELECTOR} td .spm_rich_editor h4 *, {SELECTOR} th .spm_rich_editor h4 *',
                      mobile: true,
                      properties: [{
                        name: 'line-height',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...lineHeightFieldConfig,
                    },
                    {
                      label: 'templateBuilder.fields.spaceBetweenChars',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4, {SELECTOR} .spm_rich_editor h4 *, {SELECTOR} td .spm_rich_editor h4 *, {SELECTOR} th .spm_rich_editor h4 *',
                      mobile: true,
                      properties: [{
                        name: 'letter-spacing',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...getStepperFieldConfig(StepperSignEnum.PX),
                    },
                    {
                      label: 'templateBuilder.fields.titleAlign',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4, {SELECTOR} .spm_rich_editor h4 *, {SELECTOR} td .spm_rich_editor h4 *, {SELECTOR} th .spm_rich_editor h4 *',
                      mobile: true,
                      properties: [{
                        name: 'text-align',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...getTextAlignFieldConfig(),
                    },
                    {
                      label: 'templateBuilder.fields.titleMarginVertical',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4, {SELECTOR} .spm_rich_editor h4 *, {SELECTOR} td .spm_rich_editor h4 *, {SELECTOR} th .spm_rich_editor h4 *',
                      mobile: true,
                      properties: [
                        {
                          name: 'margin-top',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'margin-bottom',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...getVerticalSpacesFieldConfig('margin', 10),
                    },
                    {
                      label: 'templateBuilder.fields.titleMarginHorizontal',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} h4, {SELECTOR} td h4, {SELECTOR} th h4, {SELECTOR} .spm_rich_editor h4 *, {SELECTOR} td .spm_rich_editor h4 *, {SELECTOR} th .spm_rich_editor h4 *',
                      mobile: true,
                      properties: [
                        {
                          name: 'margin-left',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'margin-right',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...getHorizontalSpacesFieldConfig('margin'),
                    },
                  ],
                },
                {
                  type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
                  label: 'templateBuilder.configs.button',
                  selector: 'table#spm_body',
                  items: [
                    {
                      label: 'templateBuilder.fields.buttonWidth',
                      selector: '{SELECTOR} table.spm_button th a',
                      properties: [{
                        name: 'display',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssButtonDisplayProperty(selector, property, true),
                        ],
                      }],
                      ...getButtonWidthFieldConfig(),
                    },
                    {
                      label: 'templateBuilder.fields.font',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} table.spm_button th, {SELECTOR} table.spm_button:hover th, {SELECTOR} table.spm_button:visited th, {SELECTOR} table.spm_button:active th, {SELECTOR} '
                        // eslint-disable-next-line max-len
                        + 'table.spm_button:hover th a, {SELECTOR} table.spm_button th a, {SELECTOR} table.spm_button th a:visited, {SELECTOR} table.spm_button th a:hover, {SELECTOR} table.spm_button '
                        + 'th a:active',
                      mobile: true,
                      properties: [
                        {
                          name: 'font-family',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-size',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-weight',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'font-style',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'text-decoration-line',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                        {
                          name: 'text-transform',
                          getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                          setters: [
                            (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                          ],
                        },
                      ],
                      ...fontFieldConfig,
                    },

                    {
                      label: 'templateBuilder.fields.lineHeight.label',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} table.spm_button th, {SELECTOR} table.spm_button:hover th, {SELECTOR} table.spm_button:visited th, {SELECTOR} table.spm_button:active th',
                      mobile: true,
                      properties: [{
                        name: 'line-height',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...lineHeightFieldConfig,
                    },
                    {
                      label: 'templateBuilder.fields.spaceBetweenChars',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} table.spm_button th, {SELECTOR} table.spm_button:hover th, {SELECTOR} table.spm_button:visited th, {SELECTOR} table.spm_button:active th, {SELECTOR} '
                        // eslint-disable-next-line max-len
                        + 'table.spm_button:hover th a, {SELECTOR} table.spm_button th a, {SELECTOR} table.spm_button th a:visited, {SELECTOR} table.spm_button th a:hover, {SELECTOR} table.spm_button '
                        + 'th a:active',
                      mobile: true,
                      properties: [{
                        name: 'letter-spacing',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...getStepperFieldConfig(StepperSignEnum.PX),
                    },
                    {
                      label: 'templateBuilder.fields.buttonAlignment',
                      // eslint-disable-next-line max-len
                      selector: '{SELECTOR} table.spm_button th, {SELECTOR} table.spm_button:hover th, {SELECTOR} table.spm_button:visited th, {SELECTOR} table.spm_button:active th',
                      mobile: true,
                      properties: [{
                        name: 'text-align',
                        getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                        setters: [
                          (selector: string, property: Property) => setCssPropertyWithImportant(selector, property, true),
                        ],
                      }],
                      ...getTextAlignFieldConfig(),
                    },
                  ],
                },
              ],
            },
          },
          {
            type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
            label: 'templateBuilder.configs.pageMargins',
            selector: 'table#spm_body',
            items: [
              {
                label: 'templateBuilder.fields.pageInnerMargins',
                selector: '#spm_body > tbody > tr > td',
                mobile: true,
                properties: [
                  {
                    name: 'padding-top',
                    getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                    setters: [(selector: string, property: Property) => setCssPropertyWithImportantAndRemoveIfZero(selector, property, true)],
                  },
                  {
                    name: 'padding-bottom',
                    getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                    setters: [(selector: string, property: Property) => setCssPropertyWithImportantAndRemoveIfZero(selector, property, true)],
                  },
                ],
                componentName: ComponentNameEnum.SPACES,
                options: {
                  ...getVerticalSpacesFieldConfig('padding').options,
                },
              },
              {
                label: 'templateBuilder.fields.sectionInnerMargins',
                selector: '#spm_body .spm_section > tbody > tr > td',
                mobile: true,
                properties: [
                  {
                    name: 'padding-top',
                    getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                    setters: [(selector: string, property: Property) => setCssPropertyWithImportantAndRemoveIfZero(selector, property, true)],
                  },
                  {
                    name: 'padding-bottom',
                    getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                    setters: [(selector: string, property: Property) => setCssPropertyWithImportantAndRemoveIfZero(selector, property, true)],
                  },
                ],
                componentName: ComponentNameEnum.SPACES,
                options: {
                  ...getVerticalSpacesFieldConfig('padding').options,
                },
              },
              {
                label: 'templateBuilder.fields.lineInnerMargins',
                selector: '#spm_body table.spm_draggable_row > tbody > tr > td',
                mobile: true,
                properties: [
                  {
                    name: 'padding-top',
                    getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                    setters: [(selector: string, property: Property) => setCssPropertyWithImportantAndRemoveIfZero(selector, property, true)],
                  },
                  {
                    name: 'padding-bottom',
                    getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                    setters: [(selector: string, property: Property) => setCssPropertyWithImportantAndRemoveIfZero(selector, property, true)],
                  },
                  {
                    name: 'padding-left',
                    getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                    setters: [(selector: string, property: Property) => setCssPropertyWithImportantAndRemoveIfZero(selector, property, true)],
                  },
                  {
                    name: 'padding-right',
                    getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                    setters: [(selector: string, property: Property) => setCssPropertyWithImportantAndRemoveIfZero(selector, property, true)],
                  },
                ],
                componentName: ComponentNameEnum.SPACES,
                options: {
                  ...getVerticalSpacesFieldConfig('padding').options,
                  ...getHorizontalSpacesFieldConfig('padding').options,
                },
              },
              {
                label: 'templateBuilder.fields.widgetInnerMargins',
                selector: '#spm_body table.spm_draggable_widget > tbody > tr > th',
                mobile: true,
                properties: [
                  {
                    name: 'padding-top',
                    getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                    setters: [(selector: string, property: Property) => setCssPropertyWithImportantAndRemoveIfZero(selector, property, true)],
                  },
                  {
                    name: 'padding-bottom',
                    getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                    setters: [(selector: string, property: Property) => setCssPropertyWithImportantAndRemoveIfZero(selector, property, true)],
                  },
                  {
                    name: 'padding-left',
                    getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                    setters: [(selector: string, property: Property) => setCssPropertyWithImportantAndRemoveIfZero(selector, property, true)],
                  },
                  {
                    name: 'padding-right',
                    getter: (selector: string, name: string, onlyValue: any) => getCssPropertyByName(selector, name, onlyValue, true),
                    setters: [(selector: string, property: Property) => setCssPropertyWithImportantAndRemoveIfZero(selector, property, true)],
                  },
                ],
                componentName: ComponentNameEnum.SPACES,
                options: {
                  ...getVerticalSpacesFieldConfig('padding').options,
                  ...getHorizontalSpacesFieldConfig().options,
                },
              },
            ],
          },
        ],
      },
    ],
  },
};

const pageItemConfig: ConfigurationPanelStructure = {
  items: [
    pageTabItemConfig,
  ],
};

export default pageItemConfig;
